import imgXX59 from "./../../assets/shared/desktop/image-xx59-headphones.jpg";
import imgXX99 from "./../../assets/shared/desktop/image-xx99-mark-two-headphones.jpg";
import imgXX99Markone from "./../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import imgZX7Speaker from "./../../assets/shared/desktop/image-zx7-speaker.jpg";
import imgZX9Speaker from "./../../assets/shared/desktop/image-zx9-speaker.jpg";
import earphone from "../../assets/product-yx1-earphones/desktop/image-product.jpg";

const productList = [
  {
    id: 1,
    title: "XX99 MARK I",
    price: 1750,
    img: imgXX99Markone,
    quantity: 1,
  },
  {
    id: 2,
    title: "XX99 MARK II",
    price: 2999,
    img: imgXX99,
    quantity: 1,
  },
  {
    id: 3,
    title: "XX59",
    price: 899,
    img: imgXX59,
    quantity: 1,
  },
  {
    id: 4,
    title: "YX1",
    price: 300,
    img: earphone,
    quantity: 1,
  },
  {
    id: 5,
    title: "ZX9 SPEAKER",
    price: 4500,
    img: imgZX9Speaker,
    quantity: 1,
  },
  {
    id: 6,
    title: "ZX7 SPEAKER",
    price: 3500,
    img: imgZX7Speaker,
    quantity: 1,
  },
];

export default productList;
